<template>
  <td class="not-bold">
    <span v-if="!editing" class="ske">
      {{ value || 'n.v.t' }}
    </span>
    <input v-else v-model="newVal" :placeholder="!value && 'n.v.t'">
  </td>
</template>

<script>

export default {
  props: {
    value: String,
    address: Object,
    editing: Boolean,
  },
  data() {
    return {
      newVal: this.value
    }
  },
  watch: {
    value(val) {
      this.newVal = val
    },
    newVal(val) {
      this.$emit('input', val)
    },
  },
}

</script>

<style scoped>

.not-bold {
  display: inline-block;
  margin-left: 8px;
}

</style>
